/* eslint-disable global-require */

export const clusters = require('./clusters@2x.png').default;
export const connections = require('./connections@2x.png').default;
export const jobs = require('./jobs@2x.png').default;
export const packages = require('./packages@2x.png').default;
export const schedules = require('./schedules@2x.png').default;
export const workspaces = require('./workspaces@2x.png').default;

